var map = {
	"./pin-barbers.png": 148,
	"./pin-doctors.png": 149,
	"./pin-fast-travel.png": 150,
	"./pin-fences.png": 151,
	"./pin-fishing-shops.png": 152,
	"./pin-gunsmiths.png": 153,
	"./pin-hideouts.png": 154,
	"./pin-old-jones.png": 155,
	"./pin-photo-studios.png": 156,
	"./pin-poker.png": 157,
	"./pin-post-offices.png": 158,
	"./pin-saloons.png": 159,
	"./pin-shops.png": 160,
	"./pin-stables.png": 161,
	"./pin-tailors.png": 162
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95;